import React from 'react';
import './PointSummary.css';

/**
 * PointSummary - Genbrugelig komponent til at vise point systemet
 * @param {Array} rules - Array af point regler. Hver regel skal have format: { text: string }
 * @param {string} title - Overskrift for point summary (default: "Point system:")
 */
const PointSummary = ({ rules = [], title = "Point system:" }) => {
  if (!rules || rules.length === 0) {
    return <></>;
  }

  return (
    <div className="point-summary">
      <p>{title}</p>
      <ul>
        {rules.map((rule, index) => (
          <li key={index}>{rule.text}</li>
        ))}
      </ul>
    </div>
  );
};

export default PointSummary;

